<template>
  <div class="logbooktypes">
    <span>Tipo de logbook:</span>
    <v-tabs
      ref="loobooktabs"
      mandatory
      :value="logtypesCount.findIndex(item => item.id === logtype)"
      height="38px"
      color="transparent"
    >
      <div ref="tabswrapper">
        <template v-for="(logbooktype, index) in logtypesCount">
          <v-tab
            @click="emitLogbook(logbooktype.id)"
            class="tabEl"
            :key="logbooktype.id + index"
            v-if="index < itemsVisible.count"
          >
            <v-chip
              label
              small
              :color="
                logtype === logbooktype.id ? 'secondary' : 'grey lighten-1'
              "
              text-color="white"
            >
              <span class="logbook-label">{{
                logbooktype.name ? logbooktype.name : logbooktype.label
              }}</span>
              <span class="counted">
                {{ logbooktype.count }}
              </span>
            </v-chip>
          </v-tab>
        </template>
      </div>
      <v-menu v-if="showMore" bottom class="v-tabs__div" left>
        <template v-slot:activator="{ on }">
          <a style="max-width: 100px" class="v-tabs__item" v-on="on">
            <v-chip label small color="grey lighten-1" text-color="white">
              Outros
              <v-icon>arrow_drop_down</v-icon>
            </v-chip>
          </a>
        </template>
        <v-list class="grey lighten-3">
          <template v-for="(item, index) in logtypesCount">
            <v-list-tile
              v-if="index >= itemsVisible.count"
              :key="item.id"
              @click="emitLogbook(item.id)"
            >
              {{ item.name }}
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>
    </v-tabs>
  </div>
</template>

<script>
export default {
  props: {
    logtypes: { type: Array },
    logtype: { type: String },
    logs: { type: Array }
  },
  data() {
    return {
      itemsVisible: {
        count: this.logtypes.length
      },
      items: this.logtypes,
      more: [],
      showMore: false,
      calculeSize: true
    }
  },
  computed: {
    logtypesCount() {
      const logtypesCount = this.items.map(type => {
        type.count = this.logs.filter(log => log.logbook === type.id).length
        return type
      })
      return logtypesCount
    }
  },
  methods: {
    emitLogbook(item) {
      this.$emit('update:logtype', item)
    },
    moveItem(logbooktype) {
      this.items = [
        this.items.find(item => item.id === logbooktype),
        ...this.items.filter(item => item.id !== logbooktype)
      ]
    }
  },
  mounted() {
    const fullwidth = this.$refs['loobooktabs'].$el.clientWidth
    const wrapper = this.$refs['tabswrapper'].clientWidth
    const margin = fullwidth - wrapper
    if (margin < 0) {
      let eleSum = 100
      const tabs = document.querySelectorAll('.tabEl')
      tabs.forEach((tab, index) => {
        eleSum += tab.clientWidth
        if (eleSum < fullwidth) {
          this.itemsVisible.count = index + 1
          this.logtypes.length >= index
            ? (this.showMore = true)
            : (this.showMore = false)
        }
      })
    } else {
      this.itemsVisible.count = this.logtypes.length
    }
  },
  watch: {
    logtype(val) {
      const itemIndex = this.logtypesCount.findIndex(item => item.id === val)
      if (itemIndex >= this.itemsVisible.count) {
        this.moveItem(val)
      }
    }
  }
}
</script>

<style>
.logbooktypes .v-tabs__item {
  padding: 2px 0 !important;
}
.logbooktypes .v-chip__content {
  cursor: pointer;
}
.counted {
  font-size: 10px;
  color: #000;
  border-radius: 12px;
  display: inline-block;
  padding: 3px;
  margin-right: -8px;
  margin-left: 10px;
  background-color: white;
  height: 17px;
  min-width: 17px;
}
.logbook-label {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
